export enum UserTicketStatusEnum {
  CREATED = "CREATED",
  RESERVED = "RESERVED",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
  INVALID = "INVALID",
  FREE = "FREE",
  SCANNED = "SCANNED"
}
